// extracted by mini-css-extract-plugin
export default {"typer":"Typer_typer__zojmj","shine":"Typer_shine__zKPMB"};